import { combineReducers } from 'redux';
import { ImanageProductReducer, IMaterial } from '../models';
import * as types from '../actions/actionTypes';
import initialState, { initialMaterial } from './initialState';
import {
    createTableFiltersWithName,
    modalToggleWithName
} from './commonReducers';
import { keyBy, map, pickBy } from 'lodash';

const cleanAndFilterProductObject = (product: IMaterial): IMaterial => {
    return {
        ...initialMaterial,
        ...(pickBy(product, (property, key) => property !== null) as IMaterial)
    };
};
function productsByIDReducer(
    state: { [key: string]: IMaterial } = initialState.manageProduct
        .productsByID,
    action: any
): { [key: string]: IMaterial } {
    switch (action.type) {
        case types.GET_MANAGE_PRODUCT_SUCCESS: {
            const newProducts = keyBy(
                map(action.products, (product: IMaterial) => {
                    return cleanAndFilterProductObject(product);
                }),
                'id'
            );
            return newProducts;
        }
        case types.PRODUCT_UPDATE_SUCCESS:
            return {
                ...state,
                [action.product.id]: cleanAndFilterProductObject(action.product)
            };
        case types.PRODUCT_ADD_SUCCESS:
            return {
                ...state,
                [action.product.id]: cleanAndFilterProductObject(action.product)
            };
        case types.USER_LOGOUT_SUCCESS:
            return initialState.manageInventory.productsByID;
        default:
            return state;
    }
}

function totalPages(state = 1, action: any): number {
    switch (action.type) {
        case types.PRODUCT_MANAGE_TOTAL_PAGES:
            if (action.pages && action.pages > 0) {
                return action.pages;
            }
            return state;
        case types.USER_LOGOUT_SUCCESS:
            return 1;
        default:
            return state;
    }
}

function selectedProductReducer(
    state: IMaterial = initialState.manageProduct.selectedProduct,
    action: any
): IMaterial {
    switch (action.type) {
        case types.SET_SELECTED_MANAGE_PRODUCT:
            return action.product ?? initialMaterial;
        case types.USER_LOGOUT_SUCCESS:
            return initialMaterial;
        default:
            return state;
    }
}

const ManageProduct = combineReducers<ImanageProductReducer>({
    productsByID: productsByIDReducer,
    showEditProductModal: (state, action) =>
        modalToggleWithName(state, action, 'EDIT_PRODUCT'),
    tableFilters: (state, action) =>
        createTableFiltersWithName(state, action, 'MANAGE_PRODUCT'),
    totalPages,
    selectedProduct: selectedProductReducer
});

export default ManageProduct;
